//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
import { ValidationObserver } from 'vee-validate'
import FormInput from '../Form/FormInput.vue'
import IdentificatorField from './Shared/IdentificatorField.vue'
import ROLES from '~/constants/roles'
import Button from '~/components/Shared/Button.vue'
export default {
  components: { Button, ValidationObserver, IdentificatorField, FormInput },
  data() {
    return {
      form: {
        identifier: null,
        password: null,
        identifier_type: 'identification_number',
        roles: [ROLES.PUBLIC, ROLES.EMPLOYEE, ROLES.UNEMPLOYED],
      },
    }
  },
  mounted() {
    this.setDefaultEmail(this.$route.query.email)
  },
  methods: {
    async submit() {
      try {
        const userRol = await this.$repository.user.getRole({
          identifier: this.form.identifier,
          identifier_type: this.form.identifier_type,
        })
        // eslint-disable-next-line no-console
        console.log('validate-rol:', { userRol, roles: this.form.roles })
        if (!this.form.roles.includes(userRol.type)) {
          this.toggleModalErrorRole()
          return
        }
        await this.$store.dispatch('me/login', this.form)

        if (!this.$strapi.user?.phone && !this.$strapi.user?.email) {
          await this.$router.push({ path: '/registrar-contacto' })
          return
        }
        if (!this.$strapi.user?.identification_number) {
          await this.$router.push({ path: '/registrar-identificador' })
          return
        }
        await this.$router.push({ path: '/inicio', query: { welcome: true } })
      } catch (e) {
        const idsOfMessageError = _.toArray(
          _.flatten(
            (e.response?.data?.message || []).map((message) =>
              message.messages.map(({ id }) => id)
            )
          )
        )
        let message = this.$t('misc.messages.error')
        if (
          idsOfMessageError.includes(
            'Auth.form.error.identification_number.notExist'
          )
        ) {
          this.$emit('toggle-modal-identifier-not-exist')
          return
        }
        if (idsOfMessageError.includes('Auth.form.error.blocked')) {
          this.$emit('toggle-modal-blocked-user')
          return
        }
        if (idsOfMessageError.length > 0) {
          message = idsOfMessageError
            .map((message) => {
              const keyTranslate = `api.errors.${message}`
              const translate = this.$t(`api.errors.${message}`)
              if (keyTranslate !== translate) return translate

              return this.$t('login.generalError')
            })
            .join(',')
        }

        this.$buefy.notification.open({
          message,
          type: 'is-danger',
          duration: 5000,
        })
      }
    },
    setDefaultEmail(email) {
      if (email) {
        this.form.identifier = email
      }
    },
    toggleModalResetPassword() {
      this.$emit('toggle-modal-reset-password')
    },
    toggleModalErrorRole() {
      this.$emit('toggle-modal-error-role')
    },
    onIdentificatorTypeChange(type) {
      this.form.identifier_type = type
    },
    toggleMagicLink() {
      this.$emit('toggle-magic-link')
    },
  },
}
